import React, { useState } from 'react';
import { SectionHeading } from './SectionHeading';
import { Plus, Minus } from 'lucide-react';
import { FaqItem } from '../types';

export const FAQ: React.FC = () => {
  const faqs: FaqItem[] = [
    {
      question: "Warum TikTok & Reels? Meine Kunden sind da nicht.",
      answer: "Falsch. TikTok und Instagram sind die Suchmaschinen der Neuzeit. Egal ob Gastro, Dienstleistung oder Handwerk: 80% der Kaufentscheidungen starten heute auf Social Media. Wir sorgen dafür, dass du dort gefunden wirst."
    },
    {
      question: "Wie viel Zeit muss ich investieren?",
      answer: "Minimal! Wir übernehmen alles: Strategie, Produktion, Posting. Du musst uns nur ca. 1x pro Monat Zugang gewähren, damit wir Content produzieren können. Den Rest machen wir."
    },
    {
      question: "Was ist, wenn ich keine Ideen für Content habe?",
      answer: "Kein Problem! Wir sind die Kreativ-Maschine. Wir entwickeln Formate, die zu deiner Brand passen und viral gehen. Du musst dir keine Skripte ausdenken."
    },
    {
      question: "Lohnt sich das für ein lokales Unternehmen?",
      answer: "Absolut. Social Media ist der effektivste Weg, um lokale Bekanntheit aufzubauen. Wir targetieren genau die Menschen in deinem Einzugsgebiet."
    }
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="container mx-auto px-4 max-w-3xl">
        <SectionHeading title="Noch Fragen?" />
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-100 last:border-0">
              <button
                className="w-full flex justify-between items-center py-6 text-left hover:text-brand-orange transition-colors focus:outline-none group"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className={`font-bold text-lg pr-4 ${openIndex === index ? 'text-brand-orange' : 'text-brand-dark'}`}>
                  {faq.question}
                </span>
                {openIndex === index ? 
                  <Minus className="text-brand-orange flex-shrink-0" /> : 
                  <Plus className="text-gray-400 group-hover:text-brand-orange flex-shrink-0" />
                }
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100 mb-6' : 'max-h-0 opacity-0'}`}
              >
                <div className="text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};